import { Alert, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import MembershipForm from '../Forms/MembershipForm';

const { Title } = Typography;

const Membership = () => {
    const { t } = useTranslation('onboarding');
    const { error } = useSelector((state: any) => state.auth);

    return (
        <>
            <Title
                level={3}
                className="center"
                style={{ fontWeight: 600 }}
            >
                {t('MEMBERSHIP.TITLE')}
            </Title>

            { error && (
                <Alert
                    message={`${error?.status}: ${error?.error}`}
                    type="error"
                    showIcon
                />
            )}

            <MembershipForm />
        </>
    );
};

export default Membership;
